import { AuthGuard } from '../_guards';
import { Routes } from '@angular/router';
import { RpwComponent } from './index';

export const RpwRoutes: Routes = [
  {
    path: 'safeResetPwd',
    canActivate: [AuthGuard],
    component: RpwComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/resetPassword/rpw.routes.ts